export const ServiceURL = {
    API_URL:"https://da-api.softlabsgroup.in" // --client url
    // API_URL: "https://da-api-dev.softlabsgroup.in/"
     //API_URL:"http://localhost:5171"
}